"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCountryNameByTenant = void 0;
const getCountryNameByTenant = tenant => {
  const regionNamesInEnglish = new Intl.DisplayNames(['en'], {
    type: 'region'
  });
  return regionNamesInEnglish.of(tenant.toUpperCase());
};
exports.getCountryNameByTenant = getCountryNameByTenant;